import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { Period } from '../../../components/modals/LogsModal/utils'
import { fetchProductLogs } from './fetchProductLogs'
import { getUrlWithVersion } from '../../../api/api'
import { ILogSource } from '../../../types/logs'

export const prepareProductLogs = createAsyncThunk<
    void,
    { guid: string, dates: Period, logSource?: ILogSource['path'] },
    ThunkConfig<string>
>('logsSlice/prepareProductLogs', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { guid, dates, logSource } = args
    try {
        const res = await api.post(getUrlWithVersion(`/logs/${guid}/request`), {
            period: dates.period,
            log_source: logSource,
        })

        if (res.status === 204) {
            throwSuccessMessage('No files found')
            return
        }

        if (res.status === 200) {
            dispatch(fetchProductLogs())
        }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to prepare product logs files')
    }
})
